/**
 * format-selector.js — Dubai Peptides / Dawn 15.4.1
 * Handles the "What do these formats mean?" accordion only.
 * Easify handles format selection and pricing natively.
 */

(function () {
  'use strict';

  function initExplainer() {
    const toggle = document.querySelector('.format-explainer__toggle');
    const body   = document.getElementById('format-explainer-body');
    if (!toggle || !body) return;

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      body.setAttribute('aria-hidden', String(isOpen));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExplainer);
  } else {
    initExplainer();
  }

})();
